module.exports = __webpack_public_path__ + "img/download dis-1.6cdb0d18.svg";